import SessionUI from "../../../models/sessionUI/SessionUI";

export function getScrolledUp(state: SessionUI): boolean {
  return state.scrolledUp;
}

export function getFocusedQuestionId(state: SessionUI) {
  return state.focusedQuestionId;
}
